/* eslint-disable */
import imgComputer from '../images/imgComputer.png';

export default {
  v: '5.7.4',
  fr: 29.9700012207031,
  ip: 0,
  op: 180.00000733155,
  w: 1148,
  h: 728,
  nm: 'Main',
  ddd: 0,
  assets: [{
    id: 'image_0', w: 1500, h: 930, u: '', p: imgComputer, e: 0,
  }, {
    id: 'comp_0',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [963, 307, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [-435.738, 0]],
              o: [[0, 0], [26.67, 0]],
              v: [[-820, 376], [-416.262, -105.675]],
              c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 6, ix: 5 }, lc: 2, lj: 2, bm: 0, d: [{ n: 'd', nm: 'dash', v: { a: 0, k: 0, ix: 1 } }, { n: 'g', nm: 'gap', v: { a: 0, k: 20, ix: 2 } }, { n: 'o', nm: 'offset', v: { a: 0, k: 0, ix: 7 } }], nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: { a: 0, k: 0, ix: 1 },
        e: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 13, s: [0],
          }, { t: 40.0000016292334, s: [100] }],
          ix: 2,
        },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }],
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Rocket Outlines',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100],
          }, {
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 60, s: [50],
          }, { t: 80.0000032584668, s: [100] }],
          ix: 11,
          x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
        },
        r: { a: 0, k: 81, ix: 10 },
        p: {
          a: 1,
          k: [{
            i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 0, s: [144.75, 1118.25, 0], to: [0.362, -275.376, 0], ti: [-2.47, 94.444, 0],
          }, {
            i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 10, s: [143.069, 683.242, 0], to: [14.926, -570.696, 0], ti: [0, 0, 0],
          }, { t: 40.0000016292334, s: [615.75, 200.327, 0] }],
          ix: 2,
          l: 2,
        },
        a: {
          a: 0, k: [53, 74.5, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [125.777, 125.777, 100], ix: 6, l: 2,
        },
      },
      ao: 1,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0.977, 0], [0, -0.978], [0, 0], [-0.978, 0], [0, 0.977], [0, 0]], o: [[-0.978, 0], [0, 0], [0, 0.977], [0.977, 0], [0, 0], [0, -0.978]], v: [[0.001, -8.196], [-1.768, -6.428], [-1.768, 6.428], [0.001, 8.195], [1.769, 6.428], [1.769, -6.428]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [65.34, 134.572], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0.978, 0], [0, -0.978], [0, 0], [-0.977, 0], [0, 0.977], [0, 0]], o: [[-0.977, 0], [0, 0], [0, 0.977], [0.978, 0], [0, 0], [0, -0.978]], v: [[0, -8.196], [-1.768, -6.428], [-1.768, 6.428], [0, 8.195], [1.768, 6.428], [1.768, -6.428]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [38.196, 134.572], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 2',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0.978, 0], [0, -0.977], [0, 0], [-0.978, 0], [0, 0.977], [0, 0]], o: [[-0.978, 0], [0, 0], [0, 0.977], [0.978, 0], [0, 0], [0, -0.977]], v: [[0, -8.198], [-1.768, -6.43], [-1.768, 6.43], [0, 8.198], [1.768, 6.43], [1.768, -6.43]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [103.912, 55.998], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 3',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[-0.977, 0], [0, 0.978], [0, 0], [0.977, 0], [0, -0.977], [0, 0]], o: [[0.977, 0], [0, 0], [0, -0.977], [-0.977, 0], [0, 0], [0, 0.978]], v: [[0, 8.195], [1.768, 6.428], [1.768, -6.427], [0, -8.195], [-1.768, -6.427], [-1.768, 6.428]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [16.767, 24.567], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 4',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 4,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0.977, 0], [0, -0.978], [0, 0], [-0.977, 0], [0, 0.977], [0, 0]], o: [[-0.977, 0], [0, 0], [0, 0.977], [0.977, 0], [0, 0], [0, -0.978]], v: [[0, -18.197], [-1.768, -16.429], [-1.768, 16.429], [0, 18.197], [1.768, 16.429], [1.768, -16.429]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [51.055, 90.286], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 5',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 5,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[5.328, 0], [0, 5.328], [-5.325, 0], [0, -5.328]], o: [[-5.325, 0], [0, -5.328], [5.328, 0], [0, 5.328]], v: [[-0.001, 9.661], [-9.66, 0], [-0.001, -9.661], [9.66, 0]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ind: 1,
          ty: 'sh',
          ix: 2,
          ks: {
            a: 0,
            k: {
              i: [[7.275, 0], [0, -7.276], [-7.275, 0], [0, 7.275]], o: [[-7.275, 0], [0, 7.275], [7.275, 0], [0, -7.276]], v: [[-0.001, -13.197], [-13.195, 0], [-0.001, 13.197], [13.195, 0]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 2',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'mm', mm: 1, nm: 'Merge Paths 1', mn: 'ADBE Vector Filter - Merge', hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [51.768, 51.713], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 6',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 6,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0.331, 0.332], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, -0.47], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[31.725, 61.205], [31.725, 49.199], [31.207, 47.949], [21.85, 38.592], [29.705, -8.54], [47.978, 19.404]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ind: 1,
          ty: 'sh',
          ix: 2,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[18.352, 38.081], [-0.045, 48.592], [-18.439, 38.081], [-28.193, -20.449], [-0.045, -67.368], [28.107, -20.449]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 2',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ind: 2,
          ty: 'sh',
          ix: 3,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, -0.47], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[-0.332, 0.332], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-31.294, 47.949], [-31.812, 49.199], [-31.812, 61.205], [-48.065, 19.404], [-29.792, -8.54], [-21.937, 38.592]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 3',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ind: 3,
          ty: 'sh',
          ix: 4,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0.218, 0.359], [0, 0], [0.635, -1.07], [0, 0], [-0.069, -0.414], [0, 0], [0, 0], [-0.207, -0.531], [0, 0], [-0.825, 0.149], [0, 0.849], [0, 0], [0, 0], [0, 0], [-0.546, 0.311], [0, 0], [0, 0], [0, 0], [-0.839, -0.155], [-0.107, 0], [-0.266, 0.688], [0, 0], [0.31, 0.477]], o: [[0, 0], [0.069, -0.414], [0, 0], [-0.636, -1.07], [0, 0], [-0.217, 0.359], [0, 0], [0, 0], [-0.311, 0.477], [0, 0], [0.305, 0.791], [0.84, -0.155], [0, 0], [0, 0], [0, 0], [0.545, 0.311], [0, 0], [0, 0], [0, 0], [0, 0.849], [0.108, 0.021], [0.718, 0], [0, 0], [0.207, -0.531], [0, 0]], v: [[30.565, -13.689], [31.701, -20.512], [31.473, -21.71], [1.471, -71.712], [-1.561, -71.712], [-31.56, -21.71], [-31.788, -20.512], [-30.652, -13.689], [-51.525, 18.23], [-51.691, 19.839], [-31.692, 71.27], [-29.72, 72.365], [-28.276, 70.628], [-28.276, 49.932], [-19.748, 41.406], [-0.922, 52.165], [0.832, 52.165], [19.661, 41.406], [28.19, 49.932], [28.19, 70.628], [29.632, 72.365], [29.957, 72.396], [31.604, 71.27], [51.604, 19.839], [51.438, 18.23]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 4',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'mm', mm: 1, nm: 'Merge Paths 1', mn: 'ADBE Vector Filter - Merge', hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998922909, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [51.811, 72.514], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 7',
        np: 8,
        cix: 2,
        bm: 0,
        ix: 7,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [1.746, 2.618]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [1.168, -2.921], [0, 0]], v: [[-5.423, -39.085], [-13.979, 10.432], [-4.427, 19.982], [-4.427, 39.086], [12.811, -4.005], [11.889, -12.85]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [0.97137223786, 0.720625933479, 0.082738816504, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [86.917, 108.985], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 8',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 8,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [-1.168, -2.92], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[-1.745, 2.617], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-11.889, -12.853], [-12.811, -4.008], [4.426, 39.085], [4.426, 19.982], [13.979, 10.431], [5.725, -39.085]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [0.104250201057, 0.748476933498, 0.796738508636, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [17.22, 108.985], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 9',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 9,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 182.000007413012,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Orange Cirvle (1) 2',
      sr: 1,
      ks: {
        o: {
          a: 0, k: 100, ix: 11, x: 'var $bm_rt;\n$bm_rt = transform.opacity;',
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [752.625, -81.25, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [105.703, 116.709, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          d: 1, ty: 'el', s: { a: 0, k: [23.086, 23.086], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: 'Ellipse Path 1', mn: 'ADBE Vector Shape - Ellipse', hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [0.329411764706, 0.725490196078, 0.776470648074, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 3, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr',
          p: { a: 0, k: [-509.551, 390.301], ix: 2 },
          a: { a: 0, k: [0, 0], ix: 1 },
          s: { a: 0, k: [225.271, 201.968], ix: 3 },
          r: { a: 0, k: 0, ix: 6 },
          o: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 27, s: [0],
            }, {
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100],
            }, { t: 53.0000021587343, s: [6] }],
            ix: 7,
            x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
          },
          sk: { a: 0, k: 0, ix: 4 },
          sa: { a: 0, k: 0, ix: 5 },
          nm: 'Transform',
        }],
        nm: 'Ellipse 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 182.000007413012,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_1',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 1',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 39, s: [0],
          }, {
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100],
          }, { t: 68.0000027696968, s: [0] }],
          ix: 11,
          x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [-580, -236, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [146.31, 148.711, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          d: 1, ty: 'el', s: { a: 0, k: [80.234, 80.234], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: 'Ellipse Path 1', mn: 'ADBE Vector Shape - Ellipse', hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [0.96862745098, 0.709803921569, 0.098039215686, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [565.457, 212.617], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [36.247, 35.148], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Ellipse 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 183.000007453743,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Line',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [252, 118, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]], o: [[0, 0], [0, 0]], v: [[-93.464, 614.055], [-2.749, -76.235]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tm',
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [{
              i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 2,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 3, ix: 5 }, lc: 2, lj: 2, bm: 0, d: [{ n: 'd', nm: 'dash', v: { a: 0, k: 0, ix: 1 } }, { n: 'g', nm: 'gap', v: { a: 0, k: 26, ix: 2 } }, { n: 'o', nm: 'offset', v: { a: 0, k: 0, ix: 7 } }], nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [1.742, 1.984], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [155.923, 62.818], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 183.000007453743,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_2',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Line',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [664, 208, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-73.589, 567.118], [19.779, -69.74], [-298.607, 20.378], [-392.894, 632.32], [-148.618, 601.77]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tm',
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [{
              i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 2,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        }, {
          ty: 'st',
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 4,
          },
          w: { a: 0, k: 1, ix: 5 },
          lc: 2,
          lj: 2,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [1.742, 1.984], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [155.825, 64.334], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 184.000007494474,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_3',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'Bulb',
      refId: 'comp_4',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: -14, s: [0],
          }, {
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [0],
          }, { t: 56.0000022809268, s: [100] }],
          ix: 11,
          x: 'var $bm_rt;\n$bm_rt = transform.opacity;',
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [666, 90, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [125, 125, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [37.6, 37.6, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      w: 250,
      h: 250,
      ip: -1.00000004073083,
      op: 179.000007290819,
      st: -1.00000004073083,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Line',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [664, 208, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-65.894, -54.548], [-298.607, 20.378], [-392.894, 632.32], [-93.464, 614.055], [-2.749, -76.235]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tm',
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [{
              i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 2,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        }, {
          ty: 'st',
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 4,
          },
          w: { a: 0, k: 3, ix: 5 },
          lc: 2,
          lj: 2,
          bm: 0,
          d: [{ n: 'd', nm: 'dash', v: { a: 0, k: 0, ix: 1 } }, { n: 'g', nm: 'gap', v: { a: 0, k: 26, ix: 2 } }, { n: 'o', nm: 'offset', v: { a: 0, k: 0, ix: 7 } }],
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [1.742, 1.984], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [155.923, 62.818], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 182.000007413012,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_4',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [255, 51, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          d: 1, ty: 'el', s: { a: 0, k: [65.812, 65.812], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: 'Ellipse Path 1', mn: 'ADBE Vector Shape - Ellipse', hd: false,
        }, {
          ty: 'fl',
          c: { a: 0, k: [0.96862745285, 0.709803938866, 0.098039217293, 1], ix: 4 },
          o: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100],
            }, {
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [0],
            }, { t: 40.0000016292334, s: [100] }],
            ix: 5,
            x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [-68.094, -2.094], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Ellipse 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 183.000007453743,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Bulb Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [124.654, 125, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [80.275, 116.649, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[1.666, 0], [0.267, 0.061], [0, 0], [-0.44, 1.961], [-1.936, -0.43], [0, 0], [0.44, -1.96]], o: [[-0.263, 0], [0, 0], [-1.961, -0.441], [0.444, -1.953], [0, 0], [1.961, 0.441], [-0.38, 1.692]], v: [[23.648, 9.111], [22.848, 9.022], [-24.439, -1.583], [-27.193, -5.928], [-22.848, -8.682], [24.439, 1.925], [27.193, 6.27]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998863071, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [78.456, 223.937], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[1.663, 0], [0.27, 0.06], [0, 0], [-0.444, 1.957], [-1.957, -0.43], [0, 0], [0.443, -1.958]], o: [[-0.266, 0], [0, 0], [-1.961, -0.445], [0.444, -1.961], [0, 0], [1.961, 0.444], [-0.384, 1.69]], v: [[29.104, 10.404], [28.297, 10.316], [-29.903, -2.877], [-32.648, -7.229], [-28.297, -9.975], [29.903, 3.218], [32.649, 7.57]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998863071, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [80.275, 204.457], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 2',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[1.669, 0], [0.263, 0.057], [0, 0], [-0.1, 3.293], [0, 0], [0.036, 2.675], [13.825, 14.998], [0.196, 0.239], [0, 24.393], [-38.485, 0], [0, -50.09], [19.403, -16.302], [0.06, -0.046], [0.089, -6.583], [0, 0], [0, -0.064], [0.007, -0.22], [0, 0], [1.324, -0.942], [0.408, 0.138], [0, 0], [-0.458, 1.957], [-1.953, -0.448], [0, 0], [-0.249, -0.036], [-0.021, 0.565], [0, 0], [-0.004, 0.217], [-14.827, 16.042], [-0.39, 0.192], [0, 28.973], [35.761, 0], [0, -44.935], [-17.137, -14.571], [-0.228, -0.227], [-0.132, -9.224], [0, 0], [0, 0], [-1.122, -0.344], [0, 0], [0.432, -1.961]], o: [[-0.26, 0], [0, 0], [-6.813, -2.071], [0, 0], [0.015, -0.388], [-0.092, -6.586], [-0.238, -0.176], [-18.66, -15.587], [0, -49.429], [39.338, 0], [0, 24.735], [-0.06, 0.049], [-13.825, 15.005], [0, 0], [0.004, 0.059], [0, 0.235], [0, 0], [-0.262, 3.52], [-3.052, 2.156], [0, 0], [-1.954, -0.462], [0.458, -1.958], [0, 0], [0, 0], [-0.004, -0.117], [0, 0], [-0.004, -0.267], [0.127, -9.225], [0.309, -0.334], [11.552, -10.01], [0, -45.536], [-34.986, 0], [0, 21.964], [0.27, 0.156], [14.923, 16.142], [0.046, 3.666], [0, 0], [-0.1, 3.246], [0, 0], [1.961, 0.429], [-0.373, 1.698]], v: [[29.786, 97.417], [29.001, 97.331], [-29.881, 84.372], [-36.424, 73.499], [-36.393, 71.979], [-36.393, 68.163], [-51.006, 43.73], [-51.66, 43.109], [-80.025, -17.393], [0, -97.417], [80.025, -17.393], [51.188, 43.594], [51.007, 43.734], [36.396, 68.167], [36.392, 68.512], [36.396, 68.697], [36.383, 69.379], [36.357, 69.758], [33.207, 76.061], [26.131, 76.884], [-4.017, 69.812], [-6.724, 65.436], [-2.348, 62.729], [28.177, 69.911], [29.022, 70.039], [29.114, 69.038], [29.118, 68.797], [29.122, 68.068], [46.087, 38.34], [47.145, 37.551], [72.75, -17.393], [0, -90.143], [-72.75, -17.393], [-46.928, 37.664], [-46.182, 38.236], [-29.117, 68.064], [-29.131, 72.285], [-29.153, 73.723], [-28.038, 77.342], [30.563, 90.227], [33.335, 94.561]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'fl', c: { a: 0, k: [1, 0.999998863071, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [80.275, 97.667], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 3',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 184.000007494474,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Shape Layer 1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [125, 125, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          d: 1, ty: 'el', s: { a: 0, k: [65.812, 65.812], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: 'Ellipse Path 1', mn: 'ADBE Vector Shape - Ellipse', hd: false,
        }, {
          ty: 'fl',
          c: { a: 0, k: [0.054901961237, 0.737254917622, 0.792156875134, 1], ix: 4 },
          o: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
            }, {
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100],
            }, { t: 40.0000016292334, s: [0] }],
            ix: 5,
            x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [-68.094, -2.094], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Ellipse 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 184.000007494474,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_5',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'Gears(02)',
      refId: 'comp_6',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [741, 181, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [250, 250, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [38.4, 38.4, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      w: 500,
      h: 500,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_6',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Gear Small Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, { t: 60.0000024438501, s: [180] }],
          ix: 10,
          x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
        },
        p: {
          a: 0, k: [109.84, 174.264, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [100.035, 100.035, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0.936, 2.674], [0.972, 3.866], [0, 0], [-2.51, 1.315], [0, 0], [-0.245, 2.823], [0, 0], [2.023, 1.984], [0, 0], [-1.311, 2.512], [0, 0], [-2.705, -0.845], [0, 0], [-2.164, 1.827], [0, 0], [0.027, 2.833], [0, 0], [-2.674, 0.936], [-3.866, 0.971], [0, 0], [-1.315, -2.51], [0, 0], [-2.823, -0.246], [0, 0], [-1.984, 2.024], [0, 0], [-2.512, -1.312], [0, 0], [0.844, -2.705], [0, 0], [-1.827, -2.163], [0, 0], [-2.834, 0.028], [0, 0], [-0.936, -2.675], [-0.971, -3.866], [0, 0], [2.51, -1.315], [0, 0], [0.245, -2.823], [0, 0], [-2.024, -1.984], [0, 0], [1.312, -2.512], [0, 0], [2.705, 0.843], [0, 0], [2.165, -1.827], [0, 0], [-0.027, -2.834], [0, 0], [2.675, -0.937], [3.866, -0.971], [0, 0], [1.315, 2.51], [0, 0], [2.823, 0.246], [0, 0], [1.984, -2.024], [0, 0], [2.513, 1.311], [0, 0], [-0.844, 2.705], [0, 0], [1.828, 2.163], [0, 0], [2.833, -0.028]], o: [[-2.832, 0.027], [0, 0], [-0.972, -3.866], [-0.44, -2.798], [0, 0], [2.509, -1.315], [0, 0], [0.588, -2.772], [0, 0], [-2.022, -1.984], [0, 0], [1.594, -2.342], [0, 0], [2.705, 0.844], [0, 0], [2.37, -1.551], [0, 0], [-0.027, -2.833], [0, 0], [3.866, -0.972], [2.798, -0.44], [0, 0], [1.316, 2.508], [0, 0], [2.772, 0.586], [0, 0], [1.984, -2.023], [0, 0], [2.343, 1.594], [0, 0], [-0.845, 2.705], [0, 0], [1.55, 2.371], [0, 0], [2.832, -0.027], [0, 0], [0.972, 3.867], [0.439, 2.798], [0, 0], [-2.509, 1.316], [0, 0], [-0.587, 2.772], [0, 0], [2.022, 1.984], [0, 0], [-1.594, 2.342], [0, 0], [-2.703, -0.844], [0, 0], [-2.371, 1.551], [0, 0], [0.027, 2.832], [0, 0], [-3.867, 0.973], [-2.799, 0.439], [0, 0], [-1.315, -2.508], [0, 0], [-2.771, -0.587], [0, 0], [-1.983, 2.022], [0, 0], [-2.343, -1.594], [0, 0], [0.843, -2.705], [0, 0], [-1.55, -2.371], [0, 0]], v: [[-89.254, 35.817], [-96.106, 31.005], [-97.959, 24.618], [-99.345, 18.113], [-95.582, 10.634], [-76.417, 0.59], [-71.409, -6.933], [-70.377, -13.985], [-72.987, -22.632], [-88.433, -37.78], [-89.726, -45.953], [-82.912, -57.341], [-75.097, -60.065], [-54.448, -53.616], [-45.595, -55.403], [-39.867, -59.647], [-35.606, -67.617], [-35.816, -89.253], [-31.004, -96.105], [-24.617, -97.958], [-18.112, -99.345], [-10.633, -95.581], [-0.59, -76.416], [6.934, -71.408], [13.986, -70.375], [22.632, -72.987], [37.781, -88.431], [45.954, -89.725], [57.341, -82.912], [60.066, -75.097], [53.617, -54.448], [55.404, -45.595], [59.648, -39.867], [67.618, -35.606], [89.254, -35.816], [96.106, -31.003], [97.959, -24.617], [99.346, -18.112], [95.582, -10.633], [76.417, -0.59], [71.409, 6.934], [70.376, 13.986], [72.988, 22.633], [88.432, 37.781], [89.725, 45.954], [82.912, 57.342], [75.098, 60.067], [54.447, 53.617], [45.594, 55.404], [39.868, 59.648], [35.606, 67.618], [35.817, 89.255], [31.004, 96.107], [24.618, 97.959], [18.113, 99.346], [10.634, 95.583], [0.59, 76.417], [-6.933, 71.409], [-13.986, 70.377], [-22.632, 72.988], [-37.78, 88.432], [-45.954, 89.726], [-57.341, 82.912], [-60.066, 75.098], [-53.616, 54.449], [-55.404, 45.596], [-59.648, 39.868], [-67.617, 35.607]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [100.035, 100.035], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: { a: 0, k: 0, ix: 1 },
        e: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, { t: 20.0000008146167, s: [100] }],
          ix: 2,
        },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }, {
        ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 6, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
      }],
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Inner Small Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [109.84, 174.264, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [29.46, 29.46, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -16.132], [-16.132, 0], [0, 16.132], [16.133, 0]], o: [[0, 16.132], [16.133, 0], [0, -16.132], [-16.132, 0]], v: [[-29.21, 0], [0, 29.21], [29.21, 0], [0, -29.21]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [29.46, 29.46], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: { a: 0, k: 0, ix: 1 },
        e: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, { t: 10.0000004073083, s: [100] }],
          ix: 2,
        },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }, {
        ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 6, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
      }],
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Gear BIG Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, { t: 60.0000024438501, s: [180] }],
          ix: 10,
          x: "var $bm_rt;\n$bm_rt = loopOut('cycle');",
        },
        p: {
          a: 0, k: [343.523, 291.105, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [146.302, 146.301, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0.37, 4.079], [0, 5.763], [0, 0], [-3.983, 0.959], [0, 0], [-1.338, 3.872], [0, 0], [2.137, 3.496], [0, 0], [-2.723, 3.06], [0, 0], [-3.495, -2.138], [0, 0], [-3.68, 1.801], [0, 0], [-0.961, 3.982], [0, 0], [-4.08, 0.369], [-5.764, 0], [0, 0], [-0.96, -3.983], [0, 0], [-3.872, -1.339], [0, 0], [-3.495, 2.138], [0, 0], [-3.06, -2.723], [0, 0], [2.137, -3.495], [0, 0], [-1.799, -3.681], [0, 0], [-3.983, -0.96], [0, 0], [-0.37, -4.079], [0, -5.764], [0, 0], [3.982, -0.96], [0, 0], [1.339, -3.872], [0, 0], [-2.138, -3.496], [0, 0], [2.724, -3.061], [0, 0], [3.495, 2.138], [0, 0], [3.679, -1.801], [0, 0], [0.96, -3.983], [0, 0], [4.08, -0.369], [5.763, 0], [0, 0], [0.959, 3.983], [0, 0], [3.873, 1.339], [0, 0], [3.495, -2.137], [0, 0], [3.06, 2.724], [0, 0], [-2.137, 3.494], [0, 0], [1.8, 3.68], [0, 0], [3.981, 0.961]], o: [[-3.983, -0.96], [0, 0], [0, -5.764], [0.37, -4.079], [0, 0], [3.981, -0.96], [0, 0], [1.8, -3.681], [0, 0], [-2.137, -3.495], [0, 0], [3.06, -2.723], [0, 0], [3.495, 2.138], [0, 0], [3.873, -1.339], [0, 0], [0.959, -3.983], [0, 0], [5.763, 0], [4.08, 0.369], [0, 0], [0.96, 3.982], [0, 0], [3.679, 1.801], [0, 0], [3.495, -2.137], [0, 0], [2.724, 3.06], [0, 0], [-2.138, 3.496], [0, 0], [1.339, 3.872], [0, 0], [3.982, 0.959], [0, 0], [0, 5.763], [-0.37, 4.079], [0, 0], [-3.983, 0.961], [0, 0], [-1.799, 3.68], [0, 0], [2.137, 3.494], [0, 0], [-3.06, 2.724], [0, 0], [-3.495, -2.137], [0, 0], [-3.872, 1.339], [0, 0], [-0.96, 3.983], [0, 0], [-5.764, 0], [-4.08, -0.369], [0, 0], [-0.961, -3.983], [0, 0], [-3.68, -1.801], [0, 0], [-3.495, 2.138], [0, 0], [-2.723, -3.061], [0, 0], [2.137, -3.496], [0, 0], [-1.338, -3.872], [0, 0]], v: [[-137.79, 18.773], [-145.704, 9.61], [-146.052, 0], [-145.704, -9.611], [-137.79, -18.773], [-107.373, -26.104], [-97.699, -34.889], [-93.766, -44.415], [-94.38, -57.462], [-110.701, -84.148], [-109.635, -96.066], [-96.066, -109.635], [-84.148, -110.701], [-57.461, -94.38], [-44.415, -93.766], [-34.889, -97.699], [-26.103, -107.374], [-18.773, -137.79], [-9.61, -145.704], [0.001, -146.051], [9.609, -145.704], [18.773, -137.79], [26.104, -107.374], [34.889, -97.699], [44.416, -93.766], [57.46, -94.38], [84.148, -110.702], [96.066, -109.635], [109.635, -96.066], [110.701, -84.148], [94.38, -57.462], [93.765, -44.415], [97.699, -34.889], [107.374, -26.104], [137.791, -18.773], [145.704, -9.611], [146.052, 0], [145.704, 9.61], [137.791, 18.773], [107.374, 26.103], [97.699, 34.888], [93.765, 44.415], [94.38, 57.461], [110.701, 84.148], [109.635, 96.066], [96.066, 109.634], [84.148, 110.701], [57.46, 94.379], [44.416, 93.766], [34.889, 97.698], [26.104, 107.374], [18.773, 137.79], [9.609, 145.704], [0.001, 146.051], [-9.61, 145.704], [-18.773, 137.79], [-26.103, 107.374], [-34.889, 97.698], [-44.415, 93.766], [-57.461, 94.379], [-84.148, 110.701], [-96.066, 109.634], [-109.635, 96.066], [-110.701, 84.148], [-94.38, 57.461], [-93.766, 44.415], [-97.699, 34.888], [-107.373, 26.103]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [146.302, 146.302], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100],
          }, { t: 19.0000007738859, s: [0] }],
          ix: 1,
        },
        e: { a: 0, k: 100, ix: 2 },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }, {
        ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 6, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
      }],
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Inner BIG Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 182, ix: 10 },
        p: {
          a: 0, k: [343.523, 291.106, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [58.671, 58.671, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -32.265], [-32.265, 0], [0, 32.265], [32.265, 0]], o: [[0, 32.265], [32.265, 0], [0, -32.265], [-32.265, 0]], v: [[-58.421, -0.001], [0, 58.421], [58.421, -0.001], [0, -58.421]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [58.671, 58.671], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100],
          }, { t: 10.0000004073083, s: [0] }],
          ix: 1,
        },
        e: { a: 0, k: 100, ix: 2 },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }, {
        ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 6, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
      }],
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }],
  }, {
    id: 'comp_7',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 3',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [547.5, 318.5, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0]], v: [[466.5, -185.5], [105.5, -140.5], [-1.5, 147.5], [360.5, 142.5]], c: true,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tm',
          s: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [0],
            }, { t: 50.0000020365418, s: [100] }],
            ix: 1,
          },
          e: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
            }, { t: 30.0000012219251, s: [100] }],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 183.000007453743,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Shape Layer 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [665.5, 317.5, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0]], o: [[0, 0]], v: [[602.5, 24.5]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [99.976, 103.048], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 2',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [-21, 4], [0, 0], [13, -36], [6, -6]], o: [[0, 0], [0, 0], [21, -4], [0, 0], [-13, 36], [-6, 6]], v: [[-97.5, 197.5], [34.5, -155.5], [56.5, -179.5], [502.5, -239.5], [508.5, -206.5], [364.5, 223.5]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'tm',
          s: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [0],
            }, { t: 50.0000020365418, s: [100] }],
            ix: 1,
          },
          e: {
            a: 1,
            k: [{
              i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
            }, { t: 30.0000012219251, s: [100] }],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 4,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: 'ADBE Vector Group',
        hd: false,
      }],
      ip: 0,
      op: 183.000007453743,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Shape Layer 1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [565.5, 317.5, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [0, 0, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [100, 100, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[352.5, 236.5], [352.5, 204.5], [-287.5, 204.5], [-292.75, 223.5], [-346.25, 223.5], [-354.75, 206.75], [-515.5, 206.5], [-515.5, 225], [-451.5, 238.5], [302.5, 238.5]], c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        }, {
          ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
        }, {
          ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
        }],
        nm: 'Shape 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false,
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, {
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [1],
          }, { t: 50.0000020365418, s: [100] }],
          ix: 1,
        },
        e: {
          a: 1,
          k: [{
            i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0],
          }, { t: 30.0000012219251, s: [100] }],
          ix: 2,
        },
        o: { a: 0, k: 0, ix: 3 },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false,
      }],
      ip: 0,
      op: 184.000007494474,
      st: 0,
      bm: 0,
    }, {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: 'Computer copy.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [{
            i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 29, s: [1],
          }, { t: 79.000003217736, s: [100] }],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 0, k: [572, 325, 0], ix: 2, l: 2,
        },
        a: {
          a: 0, k: [750, 465, 0], ix: 1, l: 2,
        },
        s: {
          a: 0, k: [71.703, 71.703, 100], ix: 6, l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0,
    }],
  }],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: 'Rocket 2',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [246, 576, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [400, 388, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [42.782, 42.782, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 800,
    h: 776,
    ip: 10.0000004073083,
    op: 190.000007738859,
    st: 10.0000004073083,
    bm: 0,
  }, {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: 'Line Alone',
    refId: 'comp_1',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [1035, 374, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [183, 286, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [65.035, 65.035, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 366,
    h: 572,
    ip: 29.0000011811942,
    op: 184.000007494474,
    st: 29.0000011811942,
    bm: 0,
  }, {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: 'Square ',
    refId: 'comp_2',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [608, 315, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [390, 327, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [49.777, 49.777, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 780,
    h: 654,
    ip: 10.0000004073083,
    op: 182.000007413012,
    st: 10.0000004073083,
    bm: 0,
  }, {
    ddd: 0,
    ind: 4,
    ty: 0,
    nm: 'Square Bulb',
    refId: 'comp_3',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [692, 302, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [390, 327, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [66.314, 66.314, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 780,
    h: 654,
    ip: 10.0000004073083,
    op: 184.000007494474,
    st: 10.0000004073083,
    bm: 0,
  }, {
    ddd: 0,
    ind: 5,
    ty: 0,
    nm: 'Dev',
    refId: 'comp_5',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [831, 547, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [434, 146, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [45.414, 45.414, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 868,
    h: 292,
    ip: 27.0000010997325,
    op: 180.00000733155,
    st: 27.0000010997325,
    bm: 0,
  }, {
    ddd: 0,
    ind: 6,
    ty: 0,
    nm: 'Laptop Comp ',
    refId: 'comp_7',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [610, 410, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [565.5, 317.5, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [74.167, 74.167, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    w: 1131,
    h: 635,
    ip: 0,
    op: 180.00000733155,
    st: 0,
    bm: 0,
  }],
  markers: [],
};

